// extracted by mini-css-extract-plugin
export default {"MetricRiskBadge":"MetricRiskBadge_MetricRiskBadge__zggdT","Icon":"MetricRiskBadge_Icon__MJi77","MetricRiskPDFReport":"MetricRiskBadge_MetricRiskPDFReport__Ukxto"};